import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export const Copyright = (props) => {
  return (
    <Typography variant="body2" align="center" {...props}>
      {"Copyright © "}
      <Link color="inherit" href="https://alpes-solutions.com">
        Alpes Solutions
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};
